import React from 'react';
import { useTranslation } from 'react-i18next';

import { ViewSettings } from '../../../../../viewer/view-settings';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';
import { useViewSettings } from './view-settings/use-view-settings';

const PerspectiveTool = () => {
  const { t } = useTranslation();
  const { skyview } = React.useContext(SkyviewContext);
  useViewSettings();

  return (
    <ToolIcon
      active={skyview.isClassicViewActive('tiledModel')}
      callback={() => ViewSettings.instance.showClassicView('tiledModel')}
      disabled={!skyview.is3DSceneAvailable()}
      icon={['fal', 'cube']}
      tooltip={{
        title: t('perspective.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('perspective.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { PerspectiveTool };
